import { css } from "@emotion/react"
import { alpha } from "@mui/material"
import Theme from "appearance/Theme"

export class NftPageStyle {
  static FeaturedBoxStyle = css({
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: 260,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  })

  static NftInfoWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: Theme.spacing(11, 0),
    position: "relative",
  })

  static NftTitleWrapperStyle = css({
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    position: "absolute",
    left: 0,
    right: 0,
    top: -67,
  })

  static NftInfoGridStyle = css({})

  static InfoRowStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: Theme.spacing(1, 2),
  })

  static ActionAccentStyle = css({
    marginLeft: 0,
    marginRight: 12,
    width: 28,
    height: 28,
    backgroundColor: Theme.palette.accent.main,

    "&:hover": {
      backgroundColor: Theme.palette.accent.main,
    },

    "& span": {
      fontSize: "0.9rem",
    },
  })

  static AvatarGridItemStyle = css({
    display: "flex",
    justifyContent: "center",
  })

  static AvatarStyle = css({
    border: "5px solid",
    borderRadius: "5px",
  })

  static TiresWrapperStyle = css({
    backgroundColor: "#151515",
    padding: Theme.spacing(4),
  })

  static TiresContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: Theme.spacing(4),
  })

  static SortWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: Theme.spacing(2, 0),
  })

  static RadioFormControlStyle = css({
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  })

  static RadioFormLabelStyle = css({
    fontSize: 14,
    marginRight: Theme.spacing(3),
  })

  static NftsGridStyle = css({
    paddingBottom: Theme.spacing(6),
  })

  static TitleWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: Theme.spacing(4),
  })
}
